import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ContactService, { getContactFilters } from "../../services/ContactService";
import { InstitutionalResponse, getInstitutional } from "services/PageService";
import Heading from "componentsTemplate/Heading/Heading";
import ContactCard from "components/users/ContactCard";
import FiltersPost from "components/posts/FiltersPost";
import Advertising from "components/ad/Advertising";
import Pagination from "components/table/Pagination";

export const selectStyles = {
  control: (base: any, state: any) => ({
    ...base,
    cursor: "pointer",
    borderRadius: "1.228rem",
    border: "1px solid #d8d6de",
    padding: "3px 10px",
    maxWidth: "340px",
    minWidth: "340px",
    "&:hover": {},
  }),
};

export const selectThemeColors = (theme: any) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: "#cebab1", // for option hover bg-color
    primary: "#A27C6A", // for selected option bg-color
    neutral10: "#cebab1", // for tags bg-color
    neutral20: "#cebab1", // for input border-color
    neutral30: "#cebab1", // for input hover border-color
  },
});

const Contacts: React.FC = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const [institutional, setInstitutional] = useState<InstitutionalResponse | null>(null);

  const urlBaseApi = process.env.REACT_APP_BACKEND_API_URL;
  const [banner, setBanner] = useState("");

  const [paginationData, setPaginationData] = useState<any>();
  const [filtersData, setFiltersData] = useState<any>();
  
  const fetchData = async () => {
    try {
      const data = await getInstitutional(9);
      setInstitutional(data);
    } catch (error) {
      // Lidar com erros, se necessário
    }
  };

  useEffect(() => {
    getUsers();
    fetchData();
    setLoading(false);
  }, []);

  const getUsers = async (filters = null) => {
    setLoading(true); 
    await ContactService
      .getUsers(filters)
      .then((response: any) => {

        const ids_to_remove = [47, 43, 58, 1, 2];

        // Filtre os ids que eu passar
        const filteredContacts = response.data.filter(
          (contact: any) => !ids_to_remove.includes(contact.id)
        );

        setUsers(filteredContacts);

        setPaginationData({
          current_page: response.current_page,
          last_page: response.last_page,
          per_page: response.per_page,
          total: response.total,
        });

      })
      .catch((error: any) => {
        console.error(error);
      });
  };

  // const handlePageChange = async (page: number) => {
  //   await getUsers({ page });
  //   setLoading(false);
  // }

  const handleFilters = async (filtersData: any)  => {
    await getUsers(filtersData);
    setLoading(false);
  }

  const handlePaginationChange = async (page: number) => {
    setLoading(true);
    await getUsers({ 
      ...filtersData,
      page: page,
    });
    setLoading(false);
  }

  useEffect(() => {
    if (institutional) {
      setBanner(`${urlBaseApi}/storage/images/institutional/banners/${institutional?.banners?.find((e) => e.name == 'Banner contatos')?.banner_path}`)
    }
  }, [institutional]);

  return (
    <div className="flex flex-col items-center pt-5 p-1">
      <div className="
        flex mb-2 justify-center w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem] h-96 bg-cover rounded-3xl bg-blend-darken bg-center"
        style={{ backgroundImage: `url(${banner})` }}>
        <span className="flex bg-black bg-opacity-50 w-full justify-center font-semibold text-5xl py-44 brightness-100 text-white rounded-3xl">
          {institutional?.texts?.find((e) => e.name == 'Titulo do banner')?.text ?? ''}
        </span>
      </div>
      <span className="w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem]">
        <Link to={"/"}>Home</Link> &gt;{" "}
        <Link to={"/contatos"}>Contatos</Link>
      </span>

      <div className="flex sm:px-0 w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem] my-20">
        <div className="flex flex-col lg:flex-row text-justify items-center gap-10 p-2 bg-primary-50 dark:bg-gray-600 rounded-3xl">
          <div
            className="text-justify"
            dangerouslySetInnerHTML={{
              __html: institutional?.texts?.find((e) => e.name == 'Descrição de introdução')?.text ?? ''
            }}
          ></div>
          <iframe
            className="shadow-2xl w-full sm:w-[30rem] lg:w-[50rem] h-[12rem] sm:h-[17.9rem] rounded-3xl lg:mr-[-10%]"
            width="1980"
            height="1024"
            src={institutional?.videos?.find((e) => e.name == 'Video de introdução')?.video_path ?? ''}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          ></iframe>
        </div>
      </div>

      <section>
        <div className="flex flex-col mb-10 px-4 md:px-0 lg:flex-row w-full gap-x-10 sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem]">
          <div className="w-100">
            <div className="flex-row justify-end">
              <div className="flex flex-col lg:flex-row items-start lg:items-center justify-start lg:justify-between">
                <div className="flex gap-2 xl:gap-6">
                  <span className="text-sm md:text-base"></span>
                </div>

                {/* <div className="flex gap-2 xl:gap-6 flex-wrap display-contet">
                  <div className="w-100 m-1">
                    <Select
                      placeholder="Estado"
                      value={listCategories.find(
                        (e: any) => e.value.id == categoriaSelected
                      )}
                      styles={selectStyles}
                      theme={selectThemeColors}
                      className={
                        "flex items-center rounded-full h-12  mt-5 text-primary-700 select-max-width"
                      }
                      // onChange={(e: any) => selecionarCategoria(e.value)}
                      options={listCategories}
                      isClearable={false}
                    />
                  </div> */}

                  {/* <div className="w-100 m-1">
                    {!loadingSubCategories ? (
                      <Select
                        placeholder="Cidade"
                        value={listSubCategories.find(
                          (e: any) => e.value == subCategoriaSelected
                        )}
                        styles={selectStyles}
                        theme={selectThemeColors}
                        className={
                          "flex items-center rounded-full h-12  mt-5 text-primary-700 select-max-width"
                        }
                        onChange={(e: any) => setSubCategoriaSelected(e.value)}
                        options={listSubCategories}
                        isClearable={false}
                      />
                    ) : null}
                  </div> */}

                  {/* <div className="flex items-end gap-x-2 px-4 mt-6 bg-white dark:bg-gray-400 rounded-full border border-gray-200 w-full h-full flex flex-row items-center">
                    <input
                      className="text-black bg-transparent border-transparent w-full overflow-hidden resize-none focus:rounded-l-full"
                      maxLength={42}
                      placeholder="Procurar por..."
                      onChange={(e) => setSearchValue(e.target.value)}
                    />
                    <div
                      onClick={() => setSearch(searchValue)}
                      className="flex justify-center items-center h-9 w-10 bg-primary-600 rounded-full shadow-md hover:bg-opacity-70 cursor-pointer"
                    >
                      <Icon
                        className="text-white"
                        component={Search}
                        fontSize="medium"
                      />
                    </div>
                  </div> 
                </div>*/}

              </div>
            </div>

            <FiltersPost 
              filters={['country', 'state', 'city', 'search']} 
              handleFilters={handleFilters} 
              getFilters={getContactFilters} 
              filtersData={filtersData}
              setFiltersData={setFiltersData}
            />
   
            <div className="mt-16 pb-24">
              <Heading desc={institutional?.texts?.find((e) => e.name == 'Subtitulo de listagem')?.text ?? ''}>
                {institutional?.texts?.find((e) => e.name == 'Titulo de listagem')?.text ?? ''}
              </Heading>

              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                {loading ? ( 
                  <div className="spinner border-primary-600"></div>
                ) : users.length > 0 ? (
                  <>
                    {
                      users.map((user: any, index: any) => (
                        <ContactCard user={user}/>
                      ))
                    }
                  </>
                ) : (
                  <div className="bg-primary-200 border shadow rounded-3xl w-100 p-8">
                    Nenhum usuário encontrado
                  </div>
                )}
              </div>

              {
                !loading && users.length > 0 && (
                  <div className="mt-5 flex justify-start">
                    <Pagination pagination={paginationData} fetchData={(page: number) => handlePaginationChange(page)} />
                  </div>
                )
              }

            </div>
          </div>
        </div>

        <div className="my-10">
          <Advertising type="horizontal" />
        </div>
      </section>
    </div>
  );
};

export default Contacts;
